import _typeof from "@babel/runtime/helpers/esm/typeof";
import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["origin"];
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import React, { useEffect, useState } from 'react';
import { shape, string } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import Flex from '@magalu/stereo-ui/atoms/Flex';
import Text from '@magalu/stereo-ui/atoms/Text';
import Link from '@magalu/stereo-ui/atoms/Link';
import Button from '@magalu/stereo-ui/atoms/Button';
import { useNewsletter } from '@magalu/mixer-graphql';
import { usePublisher } from '@magalu/mixer-publisher';
import withLayoutProps from '../../../hocs/withLayoutProps';
import { Container, Image, Form, Small, InputField } from './Newsletter.styles';
import { DEFAULT, SUCCESS, EMAILREGEX, ERROR } from './constants';
var validateEmail = function validateEmail(value) {
  if (value && EMAILREGEX.test(value)) {
    return true;
  }
  return false;
};
var validateName = function validateName(value) {
  if (value && value.length > 2) {
    return true;
  }
  return false;
};
var Newsletter = function Newsletter(_ref) {
  var _template$image, _template$image2, _template$image3, _template$image4, _template$image5, _template$image6, _template$link, _template$link2, _template$link3;
  var _ref$static = _ref["static"],
    origin = _ref$static.origin,
    staticProps = _objectWithoutProperties(_ref$static, _excluded);
  var _useNewsletter = useNewsletter(),
    subscribeToNewsletter = _useNewsletter.subscribeToNewsletter,
    loading = _useNewsletter.loading;
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish;
  var _useState = useState(staticProps),
    _useState2 = _slicedToArray(_useState, 2),
    template = _useState2[0],
    setTemplate = _useState2[1];
  var _useState3 = useState(DEFAULT),
    _useState4 = _slicedToArray(_useState3, 2),
    templateKey = _useState4[0],
    setTemplateKey = _useState4[1];
  var _useState5 = useState({
      error: false,
      value: ''
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    name = _useState6[0],
    setName = _useState6[1];
  var _useState7 = useState({
      error: false,
      value: ''
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    email = _useState8[0],
    setEmail = _useState8[1];
  var invalidName = staticProps.invalidName,
    invalidEmail = staticProps.invalidEmail;
  useEffect(function () {
    setTemplate(staticProps[templateKey]);
  }, [staticProps, templateKey]);
  var handleSubmit = function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(event) {
      var validName, validEmail, _yield$subscribeToNew, error;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            event.preventDefault();
            validName = validateName(name == null ? void 0 : name.value);
            validEmail = validateEmail(email == null ? void 0 : email.value);
            setName(function (curr) {
              return _extends({}, curr, {
                error: !validName
              });
            });
            setEmail(function (curr) {
              return _extends({}, curr, {
                error: !validEmail
              });
            });
            if (!(validName && validEmail)) {
              _context.next = 14;
              break;
            }
            _context.next = 8;
            return subscribeToNewsletter({
              email: email == null ? void 0 : email.value,
              name: name == null ? void 0 : name.value,
              origin: origin
            });
          case 8:
            _yield$subscribeToNew = _context.sent;
            error = _yield$subscribeToNew.error;
            if (!error) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return", setTemplateKey(ERROR));
          case 12:
            publish('newsletter:success', {
              email: email == null ? void 0 : email.value,
              name: name == null ? void 0 : name.value,
              origin: 'cr'
            });
            return _context.abrupt("return", setTemplateKey(SUCCESS));
          case 14:
            return _context.abrupt("return", null);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return React.createElement(Container, {
    bgColor: staticProps.bgColor
  }, React.createElement(Flex, {
    alignItems: "center"
  }, React.createElement(Image, {
    src: template == null ? void 0 : (_template$image = template.image) == null ? void 0 : _template$image.src,
    width: template == null ? void 0 : (_template$image2 = template.image) == null ? void 0 : _template$image2.width,
    height: template == null ? void 0 : (_template$image3 = template.image) == null ? void 0 : _template$image3.height,
    maxWidth: template == null ? void 0 : (_template$image4 = template.image) == null ? void 0 : _template$image4.width,
    maxHeight: template == null ? void 0 : (_template$image5 = template.image) == null ? void 0 : _template$image5.height,
    alt: template == null ? void 0 : (_template$image6 = template.image) == null ? void 0 : _template$image6.alt,
    imageWidth: "130px",
    imageHeight: "112px",
    lazy: true
  })), React.createElement(Flex, {
    flex: 2,
    flexDirection: "column",
    justifyContent: "center",
    gap: 3,
    py: 3
  }, React.createElement(Text, {
    as: "span",
    color: "lightest",
    fontSize: 5,
    fontWeight: "medium",
    "data-testid": "newsletter-title"
  }, template == null ? void 0 : template.title), React.createElement(Text, {
    as: "span",
    color: "lightest",
    fontSize: 2,
    fontWeight: "regular",
    lineHeight: 1.2,
    "data-testid": "newsletter-description"
  }, template == null ? void 0 : template.description), (template == null ? void 0 : (_template$link = template.link) == null ? void 0 : _template$link.text) && React.createElement(Link, {
    href: template == null ? void 0 : (_template$link2 = template.link) == null ? void 0 : _template$link2.href,
    color: "text.lightest",
    underline: true,
    p: 0,
    fontWeight: "medium",
    "data-testid": "newsletter-link"
  }, template == null ? void 0 : (_template$link3 = template.link) == null ? void 0 : _template$link3.text)), templateKey === ERROR && React.createElement(Flex, {
    justifyContent: "flex-end",
    alignItems: "center"
  }, React.createElement(Button, {
    color: "secondary",
    mr: 4,
    onClick: function onClick() {
      return setTemplateKey(DEFAULT);
    },
    "data-testid": "newsletter-error-button"
  }, "Tentar novamente")), templateKey === DEFAULT && React.createElement(Form, {
    onSubmit: handleSubmit,
    justifyContent: "space-around",
    flex: 4,
    "data-testid": "newsletter-form"
  }, React.createElement(Flex, {
    flexDirection: "column",
    justifyContent: "center",
    width: "280px"
  }, React.createElement(InputField, {
    type: "text",
    placeholder: "Digite seu nome",
    onChange: function onChange(e) {
      return setName(function (curr) {
        return _extends({}, curr, {
          value: e.target.value
        });
      });
    },
    "data-testid": "newsletter-input-name"
  }), (name == null ? void 0 : name.error) && React.createElement(Small, {
    "data-testid": "newsletter-name-helper"
  }, invalidName)), React.createElement(Flex, {
    flexDirection: "column",
    justifyContent: "center",
    width: "280px"
  }, React.createElement(InputField, {
    type: "email",
    placeholder: "Digite seu e-mail",
    onChange: function onChange(e) {
      return setEmail(function (curr) {
        return _extends({}, curr, {
          value: e.target.value
        });
      });
    },
    "data-testid": "newsletter-input-email"
  }), (email == null ? void 0 : email.error) && React.createElement(Small, {
    "data-testid": "newsletter-email-helper"
  }, invalidEmail)), React.createElement(Flex, {
    alignItems: "center"
  }, React.createElement(Button, {
    disabled: !(name == null ? void 0 : name.value) || !(email == null ? void 0 : email.value),
    color: "primary",
    type: "submit",
    "data-testid": "newsletter-submit"
  }, loading ? React.createElement(Icon, {
    name: "AnimatedLoading3"
  }) : 'Cadastrar'))));
};
process.env.NODE_ENV !== "production" ? Newsletter.propTypes = {
  "static": shape({
    bgColor: string,
    "default": shape({
      description: string,
      image: shape({
        height: string,
        src: string,
        width: string
      }),
      link: shape({
        href: string,
        text: string
      }),
      title: string
    }),
    error: shape({
      description: string,
      image: shape({
        height: string,
        src: string,
        width: string
      }),
      title: string
    }),
    invalidEmail: string,
    invalidName: string,
    origin: string,
    success: shape({
      description: string,
      image: shape({
        height: string,
        src: string,
        width: string
      }),
      title: string
    })
  })
} : void 0;
Newsletter.defaultProps = {
  "static": {}
};
Newsletter.ssr = false;
export default withLayoutProps(Newsletter);